'use strict';

angular
  .module('systemOwnerReviewControllers.ReviewUniquePermissions')

  .controller('ReviewUniquePermissionsController', [
    '$scope',
    '$state',
    '$translate',
    'topBar',
    'systemTypesToReview',
    function ($scope, $state, $translate, topBar, systemTypesToReview) {
      // When no selected system type, then go to the first one
      if ($state.is('systemOwnerReview.authUser.reviewUniquePermissions')) {
        if (systemTypesToReview.length > 0) {
          var firstSystemType = _.find(systemTypesToReview, { IsReviewed: false });
          if (_.isUndefined(firstSystemType)) {
            firstSystemType = systemTypesToReview[0];
          }

          $state.go('systemOwnerReview.authUser.reviewUniquePermissions.bySystemType', {
            systemTypeSlug: firstSystemType.Slug,
            authLogin: $scope.authLogin,
          });
        } else {
          $state.go('systemOwnerReview.authUser.reviewUniquePermissions.noSystem');
        }
      }

      // Misc
      $translate('iam.admin.systemOwnerReview.reviewUniquePermissions.pageTitle').then(function (translation) {
        topBar.setTitleAndIcon(translation, 'fa-gavel');
      });

      // Review a system type
      $scope.goToReviewSystemType = function (systemType) {
        $state.go(
          'systemOwnerReview.authUser.reviewUniquePermissions.bySystemType',
          {
            systemTypeSlug: systemType.Slug ? systemType.Slug : systemType.SystemTypeSlug,
            authLogin: $scope.authLogin,
          },
          { reload: true }
        );
      };

      // Current state, is for this system type ?
      $scope.isReviewForSystemType = function (systemType) {
        return (
          $state.includes('systemOwnerReview.authUser.reviewUniquePermissions.bySystemType') &&
          $state.params.systemTypeSlug === systemType.Slug
        );
      };
    },
  ]);
